<template>
  <div class="rotate">
    <div class="Header">
      <div class="container">
        <div class="logo"><a href="https://www.henglvwang.cn"><img src="../assets/images/logo.png" class="img"></a></div>
        <div class="navs">
          <a v-for="(item, index) in lang.navs" :class="`li ${item.isActive? 'active':''}`" :key="index" :href="item.url">{{item.name}}</a>
        </div>
        <div class="lang">
          <div v-for="(item, index) in tabs" :class="`li ${item.isActive? 'active':''}`"  :key="index" @click="switchLang" :data-key="`${item.key}`">{{item.name}}</div>
        </div>
        <div class="langs">
          <div v-for="(item, index) in tabs" :key="index" @click="switchLang" :data-key="`${item.key}`">{{ item.isActive? '': item.text}}</div>
        </div>
      </div>
    </div>
    <div class="bg">
      <div class="b-1"></div>
      <div class="b-2"></div>
      <banner :lang='lang'></banner>
      
    </div>
    <div class="robot">
      <div class="r-1"></div>
      <div class="body" @click="openDialog"><span>{{lang.ask.robot}}</span></div>
      <div class="r-2"></div>
      <div :class="`dialog ${isShow? 'open':'close'}`" >
        <div class="title"><span>“</span>{{lang.ask.title}}</div>
        <div class="close" @click="openDialog"></div>
        <div class="tabs">
          <div v-for="(item,index) in lang.ask.list" :key="index" :class="`item ${item.isSelect? 'active':''}`" :data-index="`${index}`" @click="selectQ">{{item.key}}</div>
        </div>
        <div class="content">
          <div class="question">Q: {{isSelect.q}}</div>
          <div class="ask">A: {{isSelect.a}}</div>
        </div>
      </div>
    </div>
    <div class="copyright"> {{lang.copyright}}</div>
  </div>
</template>

<script>
import langs from "@/lang/index.js"
import Banner from "@/views/banner"
export default {
  name: "rotate",
  components: {
    Banner
  },
  data () {
    return {
      index: 0,
      isShow: false,
      lang: langs['zh'].rotate,
      isSelect: '',
      tabs: [{
        key: "en",
        text: 'EN',
        name: "English",
        isActive: false
      },{
        key: "zh",
        text: '中',
        name: "中文",
        isActive: true
      }]
    }
  },
  created () {
  },
  mounted () {
    this.isSelect = this.lang.ask.list[0]
    document.title = this.lang.title
  },
  methods: {
    openDialog () {
      this.isShow = !this.isShow
    },
    switchLang(e) {
      let tabs = this.tabs
      for(let i = 0, len = tabs.length;i < len; i++){
        if(e.target.dataset.key == tabs[i].key){
          tabs[i].isActive = true
          this.lang = langs[tabs[i].key].rotate
          document.title = this.lang.title
        }else{
          tabs[i].isActive = false
        }
      }
      this.tabs = tabs

    },
    selectQ(e) {
      let list = this.lang.ask.list
      for(let i = 0, len = list.length;i < len; i++){
        if(e.target.dataset.index == i){
          list[i].isSelect = true
          this.isSelect = list[i]
        }else{
          list[i].isSelect = false
        }
      }
      this.lang.ask.list = list
    }
  }
};
</script>


<style lang="scss" scoped>
.img{
    width: 100%;
    height: 100%;
    display: block;
  }
.Header{
  width: 100vw;
  height: 6vw;
  background:#000753;
  
  .container{
    width: 63vw;
    height: auto;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    .navs{
      width: 30vw;
      position: absolute;
      top: 2.7vw;
      left: 18vw;
      z-index: 2;
      .li{
        width: 20%;
        font-size: 1vw;
        color: #fff;
        display: block;
        float: left;
        position: relative;
        text-align: center;
        
          &:hover{
            &::after{
            content: ' ';
            position: absolute;
            background: #00E2CE;
            height: 2px;
            width: 2vw;
            bottom: -1vw;
            margin: 0 auto;
            left: 0;
            right: 0;
          }
        }
        &.active::after{
          content: ' ';
          position: absolute;
          background: #00E2CE;
          height: 2px;
          width: 2vw;
          bottom: -1vw;
          margin: 0 auto;
          left: 0;
          right: 0;
        }
      }
    }
  }
  .logo{
    width: 10.8vw;
    height: 4.2vw;
    padding-top: 1vw;
  }
  .langs{
    display: none;
  }
  .lang{
    padding: 2vw;
    width: 30vw;
    position: absolute;
    right: 0;
    top: 0;
    .li{
      width: 5.5vw;
      height: 2vw;
      background: #FFFFFF;
      border: 1px solid #0D0BAD;
      border-radius: 24px;
      line-height: 2.2vw;
      text-align: center;
      font-size: 0.9vw;
      color: #0D0BAD;
      float: right;
      margin-left: 10px;
      transition: all .3s ease-in-out;
      cursor: pointer;
      &.active{
        background-image: linear-gradient(180deg, #0E0BAF 0%, #000353 100%);
        border-radius: 24px;
        color: #fff;
      }
    }
  }
}
.copyright{
    width: 100vw;
    font-size: 0.8vw;
    color: rgba(255,255,255,0.29);
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0.8vw;
  }


.bg{
  
  width: 100vw;
  height: calc(100vh - 6vw);
  background: #000753 100%;
  position: relative;
  .b-1{
    width: 11.6vw;
    height: 12vw;
    background-image: url("../assets/images/bg-top.png");
    background-size: cover;
    position: absolute;
    left: 0;
    top: -6vw;
    z-index: 1;
    animation: heartBeat infinite 10s ease-in-out;
  }
  .b-2{
    width: 4.9vw;
    height: 25.9vw;
    background-image: url("../assets/images/bg-right.png");
    background-size: cover;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    animation: flash infinite 5s ease-in-out;
  }
}
.robot{
  position: absolute;
  right: 23vw;
  top: 79vh;
  .r-1{
    width: 1.8vw;
    height: 1.7vw;
    background-image: url('../assets/images/i-robot-a-01.png');
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    animation: tada 1s ease-in-out infinite;
  }
  .r-2{
    width: 1.3vw;
    height: 1.2vw;
    background-image: url('../assets/images/i-robot-a-02.png');
    background-size: cover;
    position: absolute;
    top: 1.3vw;
    left: 6.5vw;
    animation: tada .5s ease-in-out infinite;
  }
  .body{
    width: 5.7vw;
    height: 5.7vw;
    background-image: url('../assets/images/i-robot.png');
    background-size: cover;
    position: absolute;
    top: 0.9vw;
    left: 1.2vw;
    cursor: pointer;
    span{
      position: absolute;
      bottom: -1.2vw;
      left: 0;
      right: 0;
      margin: 0 auto;
      text-align: center;
      font-size: 0.8vw;
      color: rgba(255,255,255,0.55);
    }
  }
  @keyframes openWindow
  {
    0%{display: block;left: 0; top: 0; height: 0; opacity: 0; transform:scale(0);}
    100%{width: 14.5vw; 
    height: 11.2vw; opacity: 1;transform:scale(1);
    top: -5vw;
    left: -18vw;display: block;}
  }
  @keyframes closeWindow
  {
    0% {display: block;width: 14.5vw;  
    height: 11.2vw; opacity: 1; scale: 1; transform:scale(1);top: -5vw;
    left: -18vw; }
    100%{height: 0; opacity: 0;  transform:scale(0);left: 0; top: 0; display: none;}
    
  }
  .dialog{
    
    width: 14.5vw;
    height: 11.2vw;
    background:rgba(255,255,255,0.7);
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.20);
    border-radius: 20px;
    position: absolute;
    top: -5vw;
    left: -18vw;
    padding: 0.8vw 0.8vw;
    &.close{
      visibility: hidden;
      animation: closeWindow .4s ease-in-out;
    }
    
    &.open{
      visibility: visible;
      animation: openWindow .4s ease-in-out;
      
    }
    .title{
      position: absolute;
      top: 1vw;
      left: 1vw;
      font-size: 1vw;
      line-height: 1vw;
      color: #0E0BAA;
      z-index: 0;
      span{
        font-family: Arial;
        font-size: 4vw;
        color: #0D0BAC;
        display: block;
        float: left;
        line-height: 2.5vw;
      }
    }
    .close{
      width: 0.9vw;
      height: 0.9vw;
      background-image: url('../assets/images/btn-close.png');
      background-size: cover;
      position: absolute;
      top: 1vw;
      right: 1vw;
      cursor: pointer;
      z-index: 2;
    }
    .tabs{
      width: 100%;
      float: left;
      padding-top: 1.7vw;
      z-index: 1;
      position: relative;
      .item{
        width: 30%;
        height: 1.6vw;
        background: #FFFFFF;
        border-radius: 1vw;
        float: left;
        margin-left: 0.4vw;
        margin-bottom: 0.4vw;
        text-align: center;
        line-height: 1.7vw;
        font-size: 0.7vw;
        display: block;
        cursor: pointer;
        &.active{
          background: #0D0BAB;
          color: #fff;
          transition: all .4s;
        }
        &:hover{
          background: #0D0BAB;
          color: #fff;
          transition: all .4s;
        }
      }
    }
    .content{
      width: calc(100% - 0.8vw);
      height: 4.7vw;
      overflow-x: hidden;
      overflow-y: scroll;
      background: #FFFFFF;
      border-radius: 0.5vw;
      float: left;
      padding: 0.4vw;
      .question{
        font-size: 0.7vw;
        color: #0D0BAB;
        line-height: 1.2vw;
      }
      .ask{
        padding-top: 0.3vw;
        font-size: 0.7vw;
        color: #4A4A4A;
        line-height: 1vw;
        text-align: justify;
      }
    }
  }
}
 @keyframes openW
  {
    0%{display: block;left: 0; top: 0; height: 0; opacity: 0; transform:scale(0);}
    100%{width: 75vw; 
    height: 63vw; opacity: 1;transform:scale(1);
    margin-top: -63vw;
    left: -29vw;display: block;}
  }
  @keyframes closeW
  {
    0% {display: block;height: 63vw; width: 75vw;  
    opacity: 1; scale: 1; transform:scale(1);margin-top: -63vw;
    left: -29vw; }
    100%{height: 0; opacity: 0;  transform:scale(0);left: 0; top: 0; display: none;}
    
  }
@media (max-width: 1024px){
  body{font-size: 18px}
  .Header{
    width: 100%;
    height: 17vw;
    .logo{
      width: 24vw;
      height: 9vw;
      margin: 0 auto;
      position: absolute;
      left: 0;
      right: 0;
      top: 3vw;
    }
    .container{
      width: 100%;
      .navs{
        width: 85vw;
        top: 15vh;
        left: 8vw;
        .li{
          width: 22%;
          font-size: 3vw;
          border: 2px solid #000CC4;
          color: #00E1CD;
          border-radius: 15px;
          padding: 2vw 0;
          margin-left: 1vw;
          &.active{
            background: #000CC4;
            color: #00E1CD;
            &::after{
              display: none;
            }
          }
          &:hover{
            &::after{
              display: none;
            }
          }
        }
      }
    }
    .lang{
      display: none;
    }
    .langs{
      display: block;
      width: 8vw;
      height: 8vw;
      background: #010457;
      color: #fff;
      border: 2px solid #00C7AE;
      border-radius: 5px;
      font-size: 3vw;
      line-height: 8.5vw;
      text-align: center;
      position: absolute;
      right: 4vw;
      top: 4vw;
    }
  }
  .bg{
    height: calc(100vh - 17vw);
    width: 100%;
    z-index: 0;
    .b-1{
      width: 24vw;
      height: 24vw;
      background-size: cover;
      top: -17vw;
    }
    .b-2{
      width: 12vw;
      height: 64.4vw;
      background-size: cover;
      z-index: 0;
    }
  }
  .robot{
    right: 0;
    top: 82.5vh;
    left: 0;
    margin: 0 auto;
    width: 20vw;
    z-index: 2;
    .r-1{
      width: 4.5vw;
      height: 4.5vw;
      background-size: cover;
      left: -2.5vw;
    }
    .r-2{
      width: 3.5vw;
      height: 3.5vw;
      background-size: cover;
      left: 15vw;
    }
    .body{
      width: 14vw;
      height: 14vw;
      background-size: cover;
      span{
        bottom: -3vw;
        font-size: 2.2vw;
      }
    }
    .dialog{
      width: 75vw;
      height: 63vw;
      left: -29vw;
      padding: 2vw;
      margin-top: -63vw;
      &.close{
      visibility: hidden;
      animation: closeW .4s ease-in-out;
      }
      
      &.open{
        visibility: visible;
        animation: openW .4s ease-in-out;
        
      }
      .title{
        top:6vw;
        left: 6vw;
        font-size: 4vw;
        line-height: 4vw;
        span{
          font-size: 18vw;
          line-height: 10vw;
        }
      }
      .close{
        width: 4vw;
        height: 4vw;
        top: 4vw;
        right: 4vw;
      }
      .tabs{
        padding-top: 0;
        margin-top: 11vw;
        .item{
          font-size: 3.3vw;
          line-height: 6vw;
          height: 6vw;
          border-radius: 6vw;
          margin-left: 2vw;
          margin-bottom: 2vw;
        }
      }
      .content{
        width: calc(100% - 4vw);
        height: 32vw;
        border-radius: 4vw;
        padding: 2vw;
        .question{
          font-size: 3.3vw;
          line-height: 7vw;
          font-weight: bold;
        }
        .ask{
          font-size: 3.3vw;
          line-height: 5vw;
        }
      }
    }
  }
  
  .copyright{
    font-size: 8px;
    bottom: auto;
    top: 97vh;
  }
} 
@media  (max-width: 1366px ) and ( min-width: 1024px){
  .bg{
    .b-1{
      z-index: 2;
    }
    .b-2{
      z-index: 2;
    }
  }
  .robot{
    z-index: 2;
  }
}
/*>=1024的设备*/
// @media (min-width: 1100px) {
//   body{font-size: 20px}
// } /*>=1024的设备*/
// @media (min-width: 1280px) {
//   body{font-size: 22px;}
// } 
// @media (min-width: 1366px) {
//   body{font-size: 24px;}
// }  
// @media (min-width: 1440px) {
//   body{font-size: 25px !important;}
// } 
// @media (min-width: 1680px) {
//   body{font-size: 28px;}
// } 
// @media (min-width: 1920px) {
//   body{font-size: 33px;}
// } 
</style>